// extracted by mini-css-extract-plugin
export default {"container":"Card__container___oi6Iv","operations":"Card__operations___Dwa4Q"};